import { render, staticRenderFns } from "./ContactDescriptionArea.vue?vue&type=template&id=b7dbb41e&scoped=true&"
import script from "./ContactDescriptionArea.vue?vue&type=script&lang=js&"
export * from "./ContactDescriptionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dbb41e",
  null
  
)

export default component.exports